/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as authenticatedRouteRouteImport } from './routes/(authenticated)/route'
import { Route as LoginRouteImport } from './routes/login'
import { Route as authenticatedIndexRouteImport } from './routes/(authenticated)/index'
import { Route as authenticatedSettingsRouteRouteImport } from './routes/(authenticated)/settings/route'
import { Route as authenticatedApiproxySplatRouteImport } from './routes/(authenticated)/apiproxy/$'
import { Route as authenticatedDashboardIndexRouteImport } from './routes/(authenticated)/dashboard/index'
import { Route as authenticatedMcpSplatRouteImport } from './routes/(authenticated)/mcp/$'
import { Route as authenticatedNodeIndexRouteImport } from './routes/(authenticated)/node/index'
import { Route as authenticatedProfileIndexRouteImport } from './routes/(authenticated)/profile/index'
import { Route as authenticatedSettingsIndexRouteImport } from './routes/(authenticated)/settings/index'
import { Route as authenticatedSettingsUserManagementRouteImport } from './routes/(authenticated)/settings/user-management'
import { Route as AlertLogsRefIdRouteImport } from './routes/alert/logs/$refId'
import { Route as AuthVerifyIndexRouteImport } from './routes/auth/verify/index'
import { Route as authenticatedAlertLogsIndexRouteImport } from './routes/(authenticated)/alert/logs/index'
import { Route as authenticatedSettingsAlertIndexRouteImport } from './routes/(authenticated)/settings/alert/index'
import { Route as authenticatedSettingsApikeyIndexRouteImport } from './routes/(authenticated)/settings/apikey/index'
import { Route as authenticatedSettingsNodeGroupIndexRouteImport } from './routes/(authenticated)/settings/node-group/index'
import { Route as authenticatedSettingsSmtpConfigIndexRouteImport } from './routes/(authenticated)/settings/smtp-config/index'
import { Route as authenticatedSettingsVariableIndexRouteImport } from './routes/(authenticated)/settings/variable/index'
import { Route as AuthVerifyErrorIndexRouteImport } from './routes/auth/verify/error/index'
import { Route as AuthVerifySuccessIndexRouteImport } from './routes/auth/verify/success/index'

const authenticatedRouteRoute = authenticatedRouteRouteImport.update({
  id: '/(authenticated)',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const authenticatedIndexRoute = authenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => authenticatedRouteRoute,
} as any)
const authenticatedSettingsRouteRoute =
  authenticatedSettingsRouteRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => authenticatedRouteRoute,
  } as any)
const authenticatedApiproxySplatRoute =
  authenticatedApiproxySplatRouteImport.update({
    id: '/apiproxy/$',
    path: '/apiproxy/$',
    getParentRoute: () => authenticatedRouteRoute,
  } as any)
const authenticatedDashboardIndexRoute =
  authenticatedDashboardIndexRouteImport.update({
    id: '/dashboard/',
    path: '/dashboard/',
    getParentRoute: () => authenticatedRouteRoute,
  } as any)
const authenticatedMcpSplatRoute = authenticatedMcpSplatRouteImport.update({
  id: '/mcp/$',
  path: '/mcp/$',
  getParentRoute: () => authenticatedRouteRoute,
} as any)
const authenticatedNodeIndexRoute = authenticatedNodeIndexRouteImport.update({
  id: '/node/',
  path: '/node/',
  getParentRoute: () => authenticatedRouteRoute,
} as any)
const authenticatedProfileIndexRoute =
  authenticatedProfileIndexRouteImport.update({
    id: '/profile/',
    path: '/profile/',
    getParentRoute: () => authenticatedRouteRoute,
  } as any)
const authenticatedSettingsIndexRoute =
  authenticatedSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => authenticatedSettingsRouteRoute,
  } as any)
const authenticatedSettingsUserManagementRoute =
  authenticatedSettingsUserManagementRouteImport.update({
    id: '/user-management',
    path: '/user-management',
    getParentRoute: () => authenticatedSettingsRouteRoute,
  } as any)
const AlertLogsRefIdRoute = AlertLogsRefIdRouteImport.update({
  id: '/alert/logs/$refId',
  path: '/alert/logs/$refId',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthVerifyIndexRoute = AuthVerifyIndexRouteImport.update({
  id: '/auth/verify/',
  path: '/auth/verify/',
  getParentRoute: () => rootRouteImport,
} as any)
const authenticatedAlertLogsIndexRoute =
  authenticatedAlertLogsIndexRouteImport.update({
    id: '/alert/logs/',
    path: '/alert/logs/',
    getParentRoute: () => authenticatedRouteRoute,
  } as any)
const authenticatedSettingsAlertIndexRoute =
  authenticatedSettingsAlertIndexRouteImport.update({
    id: '/alert/',
    path: '/alert/',
    getParentRoute: () => authenticatedSettingsRouteRoute,
  } as any)
const authenticatedSettingsApikeyIndexRoute =
  authenticatedSettingsApikeyIndexRouteImport.update({
    id: '/apikey/',
    path: '/apikey/',
    getParentRoute: () => authenticatedSettingsRouteRoute,
  } as any)
const authenticatedSettingsNodeGroupIndexRoute =
  authenticatedSettingsNodeGroupIndexRouteImport.update({
    id: '/node-group/',
    path: '/node-group/',
    getParentRoute: () => authenticatedSettingsRouteRoute,
  } as any)
const authenticatedSettingsSmtpConfigIndexRoute =
  authenticatedSettingsSmtpConfigIndexRouteImport.update({
    id: '/smtp-config/',
    path: '/smtp-config/',
    getParentRoute: () => authenticatedSettingsRouteRoute,
  } as any)
const authenticatedSettingsVariableIndexRoute =
  authenticatedSettingsVariableIndexRouteImport.update({
    id: '/variable/',
    path: '/variable/',
    getParentRoute: () => authenticatedSettingsRouteRoute,
  } as any)
const AuthVerifyErrorIndexRoute = AuthVerifyErrorIndexRouteImport.update({
  id: '/auth/verify/error/',
  path: '/auth/verify/error/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthVerifySuccessIndexRoute = AuthVerifySuccessIndexRouteImport.update({
  id: '/auth/verify/success/',
  path: '/auth/verify/success/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/login': typeof LoginRoute
  '/settings': typeof authenticatedSettingsRouteRouteWithChildren
  '/': typeof authenticatedIndexRoute
  '/apiproxy/$': typeof authenticatedApiproxySplatRoute
  '/mcp/$': typeof authenticatedMcpSplatRoute
  '/settings/user-management': typeof authenticatedSettingsUserManagementRoute
  '/alert/logs/$refId': typeof AlertLogsRefIdRoute
  '/dashboard/': typeof authenticatedDashboardIndexRoute
  '/node/': typeof authenticatedNodeIndexRoute
  '/profile/': typeof authenticatedProfileIndexRoute
  '/settings/': typeof authenticatedSettingsIndexRoute
  '/auth/verify/': typeof AuthVerifyIndexRoute
  '/alert/logs/': typeof authenticatedAlertLogsIndexRoute
  '/settings/alert/': typeof authenticatedSettingsAlertIndexRoute
  '/settings/apikey/': typeof authenticatedSettingsApikeyIndexRoute
  '/settings/node-group/': typeof authenticatedSettingsNodeGroupIndexRoute
  '/settings/smtp-config/': typeof authenticatedSettingsSmtpConfigIndexRoute
  '/settings/variable/': typeof authenticatedSettingsVariableIndexRoute
  '/auth/verify/error/': typeof AuthVerifyErrorIndexRoute
  '/auth/verify/success/': typeof AuthVerifySuccessIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/': typeof authenticatedIndexRoute
  '/apiproxy/$': typeof authenticatedApiproxySplatRoute
  '/mcp/$': typeof authenticatedMcpSplatRoute
  '/settings/user-management': typeof authenticatedSettingsUserManagementRoute
  '/alert/logs/$refId': typeof AlertLogsRefIdRoute
  '/dashboard': typeof authenticatedDashboardIndexRoute
  '/node': typeof authenticatedNodeIndexRoute
  '/profile': typeof authenticatedProfileIndexRoute
  '/settings': typeof authenticatedSettingsIndexRoute
  '/auth/verify': typeof AuthVerifyIndexRoute
  '/alert/logs': typeof authenticatedAlertLogsIndexRoute
  '/settings/alert': typeof authenticatedSettingsAlertIndexRoute
  '/settings/apikey': typeof authenticatedSettingsApikeyIndexRoute
  '/settings/node-group': typeof authenticatedSettingsNodeGroupIndexRoute
  '/settings/smtp-config': typeof authenticatedSettingsSmtpConfigIndexRoute
  '/settings/variable': typeof authenticatedSettingsVariableIndexRoute
  '/auth/verify/error': typeof AuthVerifyErrorIndexRoute
  '/auth/verify/success': typeof AuthVerifySuccessIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/(authenticated)': typeof authenticatedRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/(authenticated)/settings': typeof authenticatedSettingsRouteRouteWithChildren
  '/(authenticated)/': typeof authenticatedIndexRoute
  '/(authenticated)/apiproxy/$': typeof authenticatedApiproxySplatRoute
  '/(authenticated)/mcp/$': typeof authenticatedMcpSplatRoute
  '/(authenticated)/settings/user-management': typeof authenticatedSettingsUserManagementRoute
  '/alert/logs/$refId': typeof AlertLogsRefIdRoute
  '/(authenticated)/dashboard/': typeof authenticatedDashboardIndexRoute
  '/(authenticated)/node/': typeof authenticatedNodeIndexRoute
  '/(authenticated)/profile/': typeof authenticatedProfileIndexRoute
  '/(authenticated)/settings/': typeof authenticatedSettingsIndexRoute
  '/auth/verify/': typeof AuthVerifyIndexRoute
  '/(authenticated)/alert/logs/': typeof authenticatedAlertLogsIndexRoute
  '/(authenticated)/settings/alert/': typeof authenticatedSettingsAlertIndexRoute
  '/(authenticated)/settings/apikey/': typeof authenticatedSettingsApikeyIndexRoute
  '/(authenticated)/settings/node-group/': typeof authenticatedSettingsNodeGroupIndexRoute
  '/(authenticated)/settings/smtp-config/': typeof authenticatedSettingsSmtpConfigIndexRoute
  '/(authenticated)/settings/variable/': typeof authenticatedSettingsVariableIndexRoute
  '/auth/verify/error/': typeof AuthVerifyErrorIndexRoute
  '/auth/verify/success/': typeof AuthVerifySuccessIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/login'
    | '/settings'
    | '/'
    | '/apiproxy/$'
    | '/mcp/$'
    | '/settings/user-management'
    | '/alert/logs/$refId'
    | '/dashboard/'
    | '/node/'
    | '/profile/'
    | '/settings/'
    | '/auth/verify/'
    | '/alert/logs/'
    | '/settings/alert/'
    | '/settings/apikey/'
    | '/settings/node-group/'
    | '/settings/smtp-config/'
    | '/settings/variable/'
    | '/auth/verify/error/'
    | '/auth/verify/success/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/'
    | '/apiproxy/$'
    | '/mcp/$'
    | '/settings/user-management'
    | '/alert/logs/$refId'
    | '/dashboard'
    | '/node'
    | '/profile'
    | '/settings'
    | '/auth/verify'
    | '/alert/logs'
    | '/settings/alert'
    | '/settings/apikey'
    | '/settings/node-group'
    | '/settings/smtp-config'
    | '/settings/variable'
    | '/auth/verify/error'
    | '/auth/verify/success'
  id:
    | '__root__'
    | '/(authenticated)'
    | '/login'
    | '/(authenticated)/settings'
    | '/(authenticated)/'
    | '/(authenticated)/apiproxy/$'
    | '/(authenticated)/mcp/$'
    | '/(authenticated)/settings/user-management'
    | '/alert/logs/$refId'
    | '/(authenticated)/dashboard/'
    | '/(authenticated)/node/'
    | '/(authenticated)/profile/'
    | '/(authenticated)/settings/'
    | '/auth/verify/'
    | '/(authenticated)/alert/logs/'
    | '/(authenticated)/settings/alert/'
    | '/(authenticated)/settings/apikey/'
    | '/(authenticated)/settings/node-group/'
    | '/(authenticated)/settings/smtp-config/'
    | '/(authenticated)/settings/variable/'
    | '/auth/verify/error/'
    | '/auth/verify/success/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  authenticatedRouteRoute: typeof authenticatedRouteRouteWithChildren
  LoginRoute: typeof LoginRoute
  AlertLogsRefIdRoute: typeof AlertLogsRefIdRoute
  AuthVerifyIndexRoute: typeof AuthVerifyIndexRoute
  AuthVerifyErrorIndexRoute: typeof AuthVerifyErrorIndexRoute
  AuthVerifySuccessIndexRoute: typeof AuthVerifySuccessIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/(authenticated)': {
      id: '/(authenticated)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof authenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(authenticated)/': {
      id: '/(authenticated)/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof authenticatedIndexRouteImport
      parentRoute: typeof authenticatedRouteRoute
    }
    '/(authenticated)/settings': {
      id: '/(authenticated)/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof authenticatedSettingsRouteRouteImport
      parentRoute: typeof authenticatedRouteRoute
    }
    '/(authenticated)/apiproxy/$': {
      id: '/(authenticated)/apiproxy/$'
      path: '/apiproxy/$'
      fullPath: '/apiproxy/$'
      preLoaderRoute: typeof authenticatedApiproxySplatRouteImport
      parentRoute: typeof authenticatedRouteRoute
    }
    '/(authenticated)/dashboard/': {
      id: '/(authenticated)/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof authenticatedDashboardIndexRouteImport
      parentRoute: typeof authenticatedRouteRoute
    }
    '/(authenticated)/mcp/$': {
      id: '/(authenticated)/mcp/$'
      path: '/mcp/$'
      fullPath: '/mcp/$'
      preLoaderRoute: typeof authenticatedMcpSplatRouteImport
      parentRoute: typeof authenticatedRouteRoute
    }
    '/(authenticated)/node/': {
      id: '/(authenticated)/node/'
      path: '/node'
      fullPath: '/node/'
      preLoaderRoute: typeof authenticatedNodeIndexRouteImport
      parentRoute: typeof authenticatedRouteRoute
    }
    '/(authenticated)/profile/': {
      id: '/(authenticated)/profile/'
      path: '/profile'
      fullPath: '/profile/'
      preLoaderRoute: typeof authenticatedProfileIndexRouteImport
      parentRoute: typeof authenticatedRouteRoute
    }
    '/(authenticated)/settings/': {
      id: '/(authenticated)/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof authenticatedSettingsIndexRouteImport
      parentRoute: typeof authenticatedSettingsRouteRoute
    }
    '/(authenticated)/settings/user-management': {
      id: '/(authenticated)/settings/user-management'
      path: '/user-management'
      fullPath: '/settings/user-management'
      preLoaderRoute: typeof authenticatedSettingsUserManagementRouteImport
      parentRoute: typeof authenticatedSettingsRouteRoute
    }
    '/alert/logs/$refId': {
      id: '/alert/logs/$refId'
      path: '/alert/logs/$refId'
      fullPath: '/alert/logs/$refId'
      preLoaderRoute: typeof AlertLogsRefIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/verify/': {
      id: '/auth/verify/'
      path: '/auth/verify'
      fullPath: '/auth/verify/'
      preLoaderRoute: typeof AuthVerifyIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(authenticated)/alert/logs/': {
      id: '/(authenticated)/alert/logs/'
      path: '/alert/logs'
      fullPath: '/alert/logs/'
      preLoaderRoute: typeof authenticatedAlertLogsIndexRouteImport
      parentRoute: typeof authenticatedRouteRoute
    }
    '/(authenticated)/settings/alert/': {
      id: '/(authenticated)/settings/alert/'
      path: '/alert'
      fullPath: '/settings/alert/'
      preLoaderRoute: typeof authenticatedSettingsAlertIndexRouteImport
      parentRoute: typeof authenticatedSettingsRouteRoute
    }
    '/(authenticated)/settings/apikey/': {
      id: '/(authenticated)/settings/apikey/'
      path: '/apikey'
      fullPath: '/settings/apikey/'
      preLoaderRoute: typeof authenticatedSettingsApikeyIndexRouteImport
      parentRoute: typeof authenticatedSettingsRouteRoute
    }
    '/(authenticated)/settings/node-group/': {
      id: '/(authenticated)/settings/node-group/'
      path: '/node-group'
      fullPath: '/settings/node-group/'
      preLoaderRoute: typeof authenticatedSettingsNodeGroupIndexRouteImport
      parentRoute: typeof authenticatedSettingsRouteRoute
    }
    '/(authenticated)/settings/smtp-config/': {
      id: '/(authenticated)/settings/smtp-config/'
      path: '/smtp-config'
      fullPath: '/settings/smtp-config/'
      preLoaderRoute: typeof authenticatedSettingsSmtpConfigIndexRouteImport
      parentRoute: typeof authenticatedSettingsRouteRoute
    }
    '/(authenticated)/settings/variable/': {
      id: '/(authenticated)/settings/variable/'
      path: '/variable'
      fullPath: '/settings/variable/'
      preLoaderRoute: typeof authenticatedSettingsVariableIndexRouteImport
      parentRoute: typeof authenticatedSettingsRouteRoute
    }
    '/auth/verify/error/': {
      id: '/auth/verify/error/'
      path: '/auth/verify/error'
      fullPath: '/auth/verify/error/'
      preLoaderRoute: typeof AuthVerifyErrorIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/verify/success/': {
      id: '/auth/verify/success/'
      path: '/auth/verify/success'
      fullPath: '/auth/verify/success/'
      preLoaderRoute: typeof AuthVerifySuccessIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface authenticatedSettingsRouteRouteChildren {
  authenticatedSettingsUserManagementRoute: typeof authenticatedSettingsUserManagementRoute
  authenticatedSettingsIndexRoute: typeof authenticatedSettingsIndexRoute
  authenticatedSettingsAlertIndexRoute: typeof authenticatedSettingsAlertIndexRoute
  authenticatedSettingsApikeyIndexRoute: typeof authenticatedSettingsApikeyIndexRoute
  authenticatedSettingsNodeGroupIndexRoute: typeof authenticatedSettingsNodeGroupIndexRoute
  authenticatedSettingsSmtpConfigIndexRoute: typeof authenticatedSettingsSmtpConfigIndexRoute
  authenticatedSettingsVariableIndexRoute: typeof authenticatedSettingsVariableIndexRoute
}

const authenticatedSettingsRouteRouteChildren: authenticatedSettingsRouteRouteChildren =
  {
    authenticatedSettingsUserManagementRoute:
      authenticatedSettingsUserManagementRoute,
    authenticatedSettingsIndexRoute: authenticatedSettingsIndexRoute,
    authenticatedSettingsAlertIndexRoute: authenticatedSettingsAlertIndexRoute,
    authenticatedSettingsApikeyIndexRoute:
      authenticatedSettingsApikeyIndexRoute,
    authenticatedSettingsNodeGroupIndexRoute:
      authenticatedSettingsNodeGroupIndexRoute,
    authenticatedSettingsSmtpConfigIndexRoute:
      authenticatedSettingsSmtpConfigIndexRoute,
    authenticatedSettingsVariableIndexRoute:
      authenticatedSettingsVariableIndexRoute,
  }

const authenticatedSettingsRouteRouteWithChildren =
  authenticatedSettingsRouteRoute._addFileChildren(
    authenticatedSettingsRouteRouteChildren,
  )

interface authenticatedRouteRouteChildren {
  authenticatedSettingsRouteRoute: typeof authenticatedSettingsRouteRouteWithChildren
  authenticatedIndexRoute: typeof authenticatedIndexRoute
  authenticatedApiproxySplatRoute: typeof authenticatedApiproxySplatRoute
  authenticatedMcpSplatRoute: typeof authenticatedMcpSplatRoute
  authenticatedDashboardIndexRoute: typeof authenticatedDashboardIndexRoute
  authenticatedNodeIndexRoute: typeof authenticatedNodeIndexRoute
  authenticatedProfileIndexRoute: typeof authenticatedProfileIndexRoute
  authenticatedAlertLogsIndexRoute: typeof authenticatedAlertLogsIndexRoute
}

const authenticatedRouteRouteChildren: authenticatedRouteRouteChildren = {
  authenticatedSettingsRouteRoute: authenticatedSettingsRouteRouteWithChildren,
  authenticatedIndexRoute: authenticatedIndexRoute,
  authenticatedApiproxySplatRoute: authenticatedApiproxySplatRoute,
  authenticatedMcpSplatRoute: authenticatedMcpSplatRoute,
  authenticatedDashboardIndexRoute: authenticatedDashboardIndexRoute,
  authenticatedNodeIndexRoute: authenticatedNodeIndexRoute,
  authenticatedProfileIndexRoute: authenticatedProfileIndexRoute,
  authenticatedAlertLogsIndexRoute: authenticatedAlertLogsIndexRoute,
}

const authenticatedRouteRouteWithChildren =
  authenticatedRouteRoute._addFileChildren(authenticatedRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  authenticatedRouteRoute: authenticatedRouteRouteWithChildren,
  LoginRoute: LoginRoute,
  AlertLogsRefIdRoute: AlertLogsRefIdRoute,
  AuthVerifyIndexRoute: AuthVerifyIndexRoute,
  AuthVerifyErrorIndexRoute: AuthVerifyErrorIndexRoute,
  AuthVerifySuccessIndexRoute: AuthVerifySuccessIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
